<!-- {@see PChipStyles.vue} -->

<template />

<style lang="postcss">
.p-inputtext {
  @apply min-h-12 appearance-none text-ellipsis rounded-md border border-primary-100 bg-surface-0 px-3 text-surface-700 shadow-[0_1px_2px_0_rgba(18,18,23,0.05)] outline-none transition-colors duration-200 placeholder:text-gray-400 enabled:hover:border-surface-400 enabled:focus:border-primary disabled:bg-gray-100 disabled:text-surface-500 disabled:opacity-100;

  &.p-invalid {
    @apply border-red-400;
  }

  &.p-variant-filled {
    @apply bg-surface-50;
  }

  &-sm {
    @apply min-h-10 px-[0.625rem] text-sm;
  }

  &-lg {
    @apply min-h-14 px-[0.875rem] text-lg;
  }

  &-fluid {
    @apply w-full;
  }
}
</style>
